import { render, staticRenderFns } from "./invoiceMsg.vue?vue&type=template&id=b5729e92&scoped=true&"
import script from "./invoiceMsg.vue?vue&type=script&lang=js&"
export * from "./invoiceMsg.vue?vue&type=script&lang=js&"
import style0 from "./invoiceMsg.vue?vue&type=style&index=0&id=b5729e92&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5729e92",
  null
  
)

export default component.exports